<template>
  <div>
    <Panel :module="panel.module" :title="panel.title" :showFilter="panel.showFilter" :showSearch="panel.showSearch"
      :showButtons="panel.showButtons">
      <div slot="content-main">
        <div>
          <br />
          <b-tabs v-model="tabIndex" lazy>
            <b-tab v-for="(t, i) in tabs" :key="i" :title="t.title">
              <component :is="t.comp" />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel";

import GroupRent from "./GroupRent.vue";
import TypeRent from "./TypeRent.vue";

import { mapMutations, mapGetters } from "vuex";

export default {
  name: "ConfigRentalView",
  components: { Panel, GroupRent, TypeRent },
  data() {
    return {
      tabIndex: 0,
      tabs: [
        /* { title: "Grupo", comp: GroupRent },*/
        { title: "Tipo", comp: TypeRent },
      ],
      panel: {
        module: "Locação",
        title: "Configuração",
        showFilter: false,
        showSearch: false,
        showButtons: false,
      },
    };
  },
  created() {
    const saved = this.get_FilterStorage(this.$route.name);
    this.tabIndex =
      saved && typeof saved.tabIndex === "number" ? saved.tabIndex : this.tabIndex;
    this._addFilterStorage({ routeName: this.$route.name, tabIndex: this.tabIndex });
  },
  mounted() {
    this.removeLoading(["panel"]);
  },
  watch: {
    tabIndex(val) {
      this._addFilterStorage({ routeName: this.$route.name, tabIndex: val });
    },
  },
  computed: {
    ...mapGetters("generic", ["get_FilterStorage"]),
  },
  methods: {
    ...mapMutations("generic", ["_addFilterStorage", "removeLoading"]),
  },
};
</script>
